import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LocalStorageService from "./LocalStorageService";
import { useAuthenAdminMutation } from "../services/PortfolioSerivce/PortfolioService";

type pageProps = {
  pageAction: "USE_AUTH" | "NOT_USE_AUTH";
};

const middlewareAuthenticator = (
  WrappedComponent: React.ComponentType,
  page: pageProps
) => {
  return function AuthenticatedComponent() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [getAuthenAdmin, result_get_admin] = useAuthenAdminMutation();

    // Check and get previous path link before redirect to login page
    const fnCheckAndGetPreviousPathBeforeRedirectLogin = () => {
      const path_name = window.location.pathname;
      if (path_name === "/back-login") {
        setTimeout(() => {
          setLoading(true);
        }, 300);
      } else {
        navigate("/back-login");
      }
    };

    const fnGetUserProfile = async () => {
      const token = LocalStorageService.getAccessToken();
      setLoading(true);

      if (token) {
        if (page.pageAction === "NOT_USE_AUTH") {
          navigate("/back-admin");
          setLoading(true);
        } else {
          try {
            const result = await getAuthenAdmin().unwrap();
            if (result.status === 200 && token) {
              setLoading(true);
            } else {
              LocalStorageService.clearAccessToken();
              navigate("/back-login");
            }
          } catch (err) {
            navigate("/back-login");
            LocalStorageService.clearAccessToken();
          }
        }
      } else {
        fnCheckAndGetPreviousPathBeforeRedirectLogin();
      }
    };

    useEffect(() => {
      fnGetUserProfile();
    }, []);

    if (loading) {
      return <WrappedComponent />;
    } else {
      return (
        <div className="h-[200px] w-full flex flex-col justify-center items-center">
          <div className="h-[60px] w-[60px] rounded-[100px] border-solid border-[7px] border-custom-primary-25  border-b-custom-secondary-50 animate-spin"></div>
        </div>
      );
    }
  };
};

export default middlewareAuthenticator;
